import { connect } from 'react-redux';
import Login from '../../components/Login';

const mapState = (state) => ({
  isConnected: state.user.isConnected,
  informations: state.user.informations,
  validation: state.user.validation,
});

const mapDispatch = (dispatch) => ({
  logout: () => {
    const action = logout();
    dispatch(action);
  },
  validate: (data) => {
    const action = validate(data);
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(Login);
